import { z } from 'zod';
import { isoDateStringSchema, uuidSchema } from './common';

const completionPolicySchema = z.enum([
  'manual',
  'derived-all-items',
  'auto-on-event',
  'time-elapsed',
]);
export type HabitCompletionPolicy = z.infer<typeof completionPolicySchema>;

const isoDateOnly = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

export const habitSchema = z.object({
  id: uuidSchema,
  title: z.string(),
  recurrenceDays: z.number().int().positive(),
  anchorDate: isoDateOnly,
  nextDueAt: isoDateStringSchema,
  lastSpawnedAt: isoDateStringSchema.nullable(),
  completionPolicy: completionPolicySchema,
  createdAt: isoDateStringSchema,
});
export type Habit = z.infer<typeof habitSchema>;

export const createHabitRequestSchema = z.object({
  title: z.string().min(1).max(200),
  recurrenceDays: z.number().int().positive().max(365),
  anchorDate: isoDateOnly,
  completionPolicy: completionPolicySchema.optional(),
});
export type CreateHabitRequest = z.infer<typeof createHabitRequestSchema>;

export const updateHabitRequestSchema = z
  .object({
    title: z.string().min(1).max(200).optional(),
    recurrenceDays: z.number().int().positive().max(365).optional(),
    anchorDate: isoDateOnly.optional(),
    completionPolicy: completionPolicySchema.optional(),
  })
  .refine((v) => Object.values(v).some((x) => x !== undefined), {
    message: 'At least one field must be provided',
  });
export type UpdateHabitRequest = z.infer<typeof updateHabitRequestSchema>;
